<template>
<div>
    <slot></slot>
</div>

</template>

<script>
import { gsap } from "gsap";
export default {
    name: 'appear',
    mounted(){

        this.tl = gsap.timeline({ paused: true });
        this.initAnim();
    },
      methods: {
        initAnim() {
        let el = this.$slots.default[0].elm;

    //   let el = document.querySelector(".subpage-hero-bg img");
    //   let el2 = document.querySelector(".subpage-hero-bg");

    //   this.tl.to(el, { duration: 1, filter: "brightness(.4)" }, "same");

      this.tl.to(el, { duration: 3, alpha: 0.1 });
      this.tl.play()
    },


  }

}
</script>

<style>

</style>